import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipsuranceTitle: {
    description: 'Account setup settings page title for the Shipsurance product',
    defaultMessage: 'Shipsurance Account Setup',
    id: 'tzC3lO',
  },
  directions: {
    description: 'Prompt for filling out the account set up form',
    defaultMessage: 'Enter your Shipsurance account credentials below to connect it with ShipStation:',
    id: 'RPY5+W',
  },
  emailLabel: {
    description: 'Account email input label',
    defaultMessage: 'Email',
    id: 'KYoaWE',
  },
  policyIdLabel: {
    description: 'Account policy id input label',
    defaultMessage: 'Policy ID',
    id: 'mf32hS',
  },
  enableShipsurance: {
    description: "Label for form submission that updates the user's credentials for the Shipsurance product",
    defaultMessage: 'Update Shipsurance Credentials',
    id: 'oCtNi0',
  },
  apiSuccess: {
    description: "Success notification message for updating the user's credentials for the Shipsurance product",
    defaultMessage: 'Your Shipsurance credentials have been updated.',
    id: 'xLGUt5',
  },
  apiSuccessTitle: {
    description: "Success notification title for updating the user's credentials for the Shipsurance product",
    defaultMessage: 'Success',
    id: 'iBHkFs',
  },
  apiFailure: {
    description: "Failure notification message for updating the user's credentials for the Shipsurance product",
    defaultMessage: 'Failed to save your Shipsurance credentials',
    id: 'bdP2ua',
  },
  apiFailureTitle: {
    description: "Failure notification title for updating the user's credentials for the Shipsurance product",
    defaultMessage: 'Error',
    id: 'qBDvaN',
  },
  existingPersonalShipsuranceBanner: {
    description: 'Banner message describing the user can update the credentials for the Shipsurance product',
    defaultMessage:
      'A personal Shipsurance account already exists for this seller. To update this Shipsurance account, please use the form below.',
    id: 'KAN4Tj',
  },
  remainingBalanceBanner: {
    description: 'Banner message warning the funds remaining on the Shipsurance balance will need manual work to get refunded',
    defaultMessage:
      'You currently have {amount} remaining in your Shipsurance balance. You cannot access these funds after you connect your personal Shipsurance account. Please contact support to request a refund.',
    id: 'Wsn2tL',
  },
  defaultBanner: {
    description:
      "Banner message describing the change in app behavior when using the user's own credentials for the Shipsurance insurance product",
    defaultMessage: 'When using your own Shipsurance account, you must submit any claims directly with Shipsurance.',
    id: 'ZtLkIL',
  },
});
